
const layout = () => import('./components/ui/layout')
const Lender = () => import('./pages/Lender')
const Review = () => import('./pages/Review')

export default [
  {
    path: '/lender',
    component: layout,
    children: [
      {
        path: 'private/:productId',
        name: 'LenderPrivate',
        component: Lender,
        props: true,
        meta: {
          accessAnyWhere: true,
          title: 'Lender Information - Private View',
        },
      },
      {
        path: ':dealId/:productId',
        name: 'Lender',
        component: Lender,
        props: true,
        meta: {
          accessAnyWhere: true,
          title: 'Match',
        },
      },
      {
        path: ':dealId/:productId/review/:reviewId',
        name: 'ReviewLender',
        component: Review,
        props: true,
        meta: {
          accessAnyWhere: true,
          title: 'Review Lender',
        },
      },
    ],
  },
]
